import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { FocusLock } from '@bingads-webui-react/focus-lock';
import { DropdownBtnComponent } from './dropdown-btn';

/**
 * A HOC provide components with dropdown menu
 */

export const withDropdownMenu = WrappedComponent =>
  onClickOutside(class extends React.Component {
    static propTypes = {
      /**
       * i18n for the initail tips to show
       */
      i18n: PropTypes.shape({
        getString: PropTypes.func.isRequired,
        parseDecimal: PropTypes.func.isRequired,
      }).isRequired,
      /**
       * dropdownOptions for this HOC
       */
      dropdownOptions: PropTypes.shape({
        /**
         * toggle dropdown menu
         */
        toggle: PropTypes.func.isRequired,
        /**
         * is the dropdown menu toggled
         */
        isToggled: PropTypes.bool.isRequired,
        /**
         * render the customized dropdown text
         */
        renderDropdownText: PropTypes.func,
        /**
         * render the customized dropdown text when not selected
         */
        renderEmptyDropdownText: PropTypes.func,
        /**
        * initial selected item
        */
        selectedItem: PropTypes.objectOf(PropTypes.any),
        /**
        * update the selectedItem in the dropdown btn
        */
        updatedDropdownItem: PropTypes.func,
        /**
         * focus first item on mount
        */
        focusFirstItemOnMount: PropTypes.bool,
        /**
         * aria-label
        */
        ariaLabel: PropTypes.string,
        /**
         * disable the dropdown menu
         */
        disabled: PropTypes.bool,
      }).isRequired,
    };

    /**
     * toggle the dropdown menu while click outside
     * @returns {undefined} update the toggle state
     */
    handleClickOutside = () => {
      if (this.props.dropdownOptions.isToggled) {
        this.props.dropdownOptions.toggle();
      }
    }

    render() {
      const { isToggled, focusFirstItemOnMount } = this.props.dropdownOptions;

      return (
        <div className={classnames('with-dropdown-container', { open: isToggled })} >
          <DropdownBtnComponent
            {...this.props}
            dropdownOptions={
              {
                ...this.props.dropdownOptions,
                handleClickOutside: this.handleClickOutside,
              }
            }
          />
          <div className={classnames('dropdown-menu', 'react-dropdown-menu')} >
            <FocusLock
              onExit={this.handleClickOutside}
              focusFirstItemOnMount={focusFirstItemOnMount}
              isControlledFocusLock
              isFocusLock={isToggled}
            >
              <WrappedComponent
                {...this.props}
              />
            </FocusLock>
          </div>
        </div>
      );
    }
  });
